import { IScheduleEvent } from "../../redux/reducers/schedule.reducer";
import Box from "@mui/material/Box";
import AlarmIcon from "@mui/icons-material/Alarm";
import { ColorCodeType } from "./MonthlyCalendar";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import moment from "moment";

import FiberNewIcon from "@mui/icons-material/FiberNew";

export type ColorType = {
  [key: string]: string;
};

type LoadMonthEventPropsType = {
  allEvents: IScheduleEvent[];
  fullDate: string;
  handleEventSelect: Function;
  colorCodes: ColorCodeType;
};

let scheduleStatus: { [key: number]: string } = {
  0: "Closed",
  1: "Opened",
  2: "Unassigned",
  3: "Unfulfilled",
  4: "Fulfilled",
  5: "Assigned",
};

export default function LoadMonthEvents(props: LoadMonthEventPropsType) {
  const { fullDate, allEvents, handleEventSelect, colorCodes } = props;

  //select current date events only
  let currentDateEvents = allEvents?.filter((event: IScheduleEvent, index) => {
    if (event?.schedule_date === fullDate) {
      return true;
    } else return false;
  });
  currentDateEvents?.sort((a: IScheduleEvent, b: IScheduleEvent) => {
    return +a.schedule_status - +b.schedule_status;
  });

  return (
    <Box>
      {currentDateEvents?.map((event: IScheduleEvent, index) => {
        //get the color from the schedule status in option 0,1,2,3,4,5

        // let isPastEvent = false;
        // let currentDateObj = moment();

        let startTimeObj = moment(event.start_time);
        let endTimeObj = moment(event.end_time);
        let isOvernight = false;
        // if (currentDateObj >= endTimeObj) isPastEvent = true;
        if (
          startTimeObj?.format("YYYY-MM-DD") !==
          endTimeObj?.format("YYYY-MM-DD")
        ) {
          isOvernight = true;
        }

        if (
          new Date(event.start_time).getDate() !==
          new Date(event.end_time).getDate()
        ) {
          isOvernight = true;
        }
        let color = colorCodes[event?.schedule_status];

        return (
          <Box
            onClick={(e) => handleEventSelect(e, event)}
            key={index}
            className="event-box"
            sx={{
              border: `1px solid ${color}`,
              backgroundColor: color,
              borderRadius: "4px",
              margin: "0.4rem 0",
              cursor: "pointer",
              color: "white",
              fontWeight: 800,
              px: 0.5,
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box aria-label="time-detail" display="flex" alignItems="center">
                <AlarmIcon
                  sx={{
                    height: "15px",
                    width: "15px",
                    mr: 0.5,
                    color: "#ffffff",
                  }}
                />
                {event.start_time?.slice(11, 16)}~
                {event.end_time?.slice(11, 16)}
              </Box>
              {isOvernight && (
                <Box>
                  <NightsStayIcon sx={{ height: "14px" }} />
                </Box>
              )}
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box fontSize="0.7rem">
                {scheduleStatus[event?.schedule_status]}
              </Box>
              {event?.new_schedule && (
                <Box>
                  <FiberNewIcon sx={{ alignSelf: "center" }} />
                </Box>
              )}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
